<template>
  <header :class="shadow">
    <div class="container">
      <el-row>
        <el-col :span="8">
          <router-link to="/" class="logo">
            <img :src="logoSrc" alt />
          </router-link>
        </el-col>
        <el-col :span="16">
          <template v-if="isShow">
            <el-row :gutter="20" type="flex" justify="end" class="nav">
              <el-col :span="4" class="nav-item" v-for="(item, index) in this.navData" :key="index">
                <a class="nav-link" :class="item.isActive" @click="anchors(index)">{{ item.name }}</a>
              </el-col>
            </el-row>
          </template>
        </el-col>
      </el-row>
    </div>
  </header>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      shadow: "",
      isShow: true,
      logoSrc: require("../assets/images/getech/logo.png"),
      navData: [
        {
          name: "飞讯平台",
          path: "/",
          isActive: "active",
        },
        {
          name: "系统演示",
          path: "/system",
          isActive: "",
        },
        {
          name: "数字看板",
          path: "/screen",
          isActive: "",
        },
        {
          name: "关于我们",
          path: "http://www.feixuns.com",
          isActive: "",
        },
      ],
    };
  },
  watch: {},
  methods: {
    scrollHandle(e) {
      let top = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
      if (top > 85) {
        this.shadow = "shadow";
      } else {
        this.shadow = "";
      }
    },
    anchors(index) {
      let currentIndex = index;
      // console.log(index);
      this.navData.forEach((item, index) => {
        if (currentIndex == index) {
          item.isActive = "active";
        } else {
          item.isActive = "";
        }
      });
      if (currentIndex == 3) {
        window.open("http://www.feixuns.com", "feixun");
      } else {
        this.$router.push({
          path: this.navData[index].path,
        });
      }
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.scrollHandle); //绑定页面滚动事件
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
